import filter from "lodash/filter";
import isNil from "lodash/isNil";
import { ComponentProps } from "PFApp/components/activity_form/field_factory/component_prop_types";
import { Checkbox } from "PFComponents/checkbox";
import { Stack } from "PFComponents/containers";
import { CheckboxesFieldValue } from "PFCore/types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { SidePanelCellFormSection } from "../side_panel_cell_form_section";

type CheckboxesCellProps = Pick<
  ComponentProps,
  "property" | "disabled" | "error" | "tabIndex" | "style" | "inputRef"
> & {
  title: string;
  value?: CheckboxesFieldValue;
  onChange: (newValue: CheckboxesFieldValue) => void;
};

export const CheckboxesCell = ({
  title,
  property,
  value = [],
  disabled,
  error,
  tabIndex,
  style,
  inputRef,
  onChange
}: CheckboxesCellProps) => {
  const { t: tCheckboxes } = useTranslation("activities", { keyPrefix: "form.sections.checkboxes" });

  const handleCheckboxChange = (id: string, checked: boolean) => {
    const newValue = [...value];
    const checkboxIndex = newValue.findIndex((checkbox) => checkbox.id === id);

    if (checkboxIndex < 0) {
      newValue.push({ id, value: checked });
    } else {
      newValue[checkboxIndex].value = checked;
    }

    onChange(newValue);
  };

  const displayText = useMemo(() => {
    const count = filter(value, "value").length;
    return count ? tCheckboxes("countSelected", { count }) : tCheckboxes("noneSelected");
  }, [value, tCheckboxes]);

  return (
    <SidePanelCellFormSection
      label={displayText}
      sidePanelTitle={title}
      disabled={disabled}
      error={error}
      inputFocusProps={!isNil(tabIndex) && !isNil(style) ? { tabIndex, style } : undefined}
      buttonRef={inputRef}
    >
      <Stack gap="spacingMd">
        {property.options?.map(({ id, label }) => (
          <Checkbox
            key={id}
            checked={Boolean(value.find((checkbox) => checkbox.id === id)?.value)}
            onChange={(checked) => handleCheckboxChange(id, checked)}
            label={label}
          />
        ))}
      </Stack>
    </SidePanelCellFormSection>
  );
};
